import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Video from "../elements/Video"
import Tags from "../elements/Tags"

import event_1 from "../../images/events/july/event-1.mp4"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". . culture-1 culture-1" "culture-2 culture-2 . ." ". . culture-3 culture-3" "culture-4 culture-4 . .";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  .culture-3 {
    grid-area: culture-3;
  }
  .culture-4 {
    grid-area: culture-4;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." "event-2 event-2 . ." ". . culture-1 ." ". culture-2 culture-1 ." ". culture-2 culture-3 ." ". culture-4 culture-3 ." ". culture-4 . .";
  }
  @media (min-width: 1200px) {
  }
`

const July = () => {
  const data = useStaticQuery(graphql`
    query {
      julyEventOneFB: file(relativePath: { eq: "events/july/event-1-fb.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 480, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      julyEventTwo: file(relativePath: { eq: "events/july/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 724, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      julyCultureOne: file(relativePath: { eq: "events/july/culture-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 700, maxHeight: 702, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      julyCultureTwo: file(relativePath: { eq: "events/july/culture-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 540, maxHeight: 540, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      julyCultureThree: file(
        relativePath: { eq: "events/july/culture-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      julyCultureFour: file(relativePath: { eq: "events/july/culture-4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="july">
      <Grid>
        <Block className="event-1">
          {isMobile ? (
            <Photo img={data.julyEventOneFB} maxWidth={800} maxHeight={480} />
          ) : (
            <Video src={event_1} width={720} height={434} />
          )}
          <h4 style={{ maxWidth: 720 }}>
            We launched a new identity and website for the South African
            International Tattoo{" "}
            <a
              href="https://www.southafricantattooconvention.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Convention
            </a>
            .
          </h4>
          <Tags maxWidth={800} words={["react", "gatsbyjs", "gsap"]} />
        </Block>

        <Block className="event-2">
          <Photo img={data.julyEventTwo} maxWidth={724} maxHeight={600} />
          <h4 style={{ maxWidth: 724 }}>
            It features 90 of the finest tattoo{" "}
            <a
              href="https://www.southafricantattooconvention.com/artists"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              artists
            </a>{" "}
            from around the world.
          </h4>
        </Block>

        <Block className="culture-1">
          <Photo img={data.julyCultureOne} maxWidth={700} maxHeight={702} />
          <h4 style={{ maxWidth: 700 }}>
            We had a blast at the AWS Summit in Cape Town.
          </h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.julyCultureTwo} maxWidth={540} maxHeight={540} />
          <h4 style={{ maxWidth: 540 }}>
            <a
              href="https://www.instagram.com/p/Bz0EfTaD9IF/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              Simon
            </a>{" "}
            had a few more blasts later that night 🍺
          </h4>
        </Block>
        <Block className="culture-3">
          <Photo img={data.julyCultureThree} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>Zego aged by another year.</h4>
        </Block>
        <Block className="culture-4">
          <Photo img={data.julyCultureFour} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>Ryan turned… old(er).</h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default July
